import { Controller } from "@hotwired/stimulus";
import "emoji-picker-element";

// Full emoji picker (emoji-picker-element) for Slack sender emoji on coach/sysadmin profiles.
export default class extends Controller {
  static targets = ["input", "panel"];

  connect() {
    this.picker = this.panelTarget.querySelector("emoji-picker");
    if (!this.picker) {
      this.picker = document.createElement("emoji-picker");
      this.panelTarget.appendChild(this.picker);
    }

    this.onEmojiClick = (event) => {
      if (!this.hasInputTarget) return;

      this.inputTarget.value = event.detail.unicode;
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
      this.close();
    };
    this.picker.addEventListener("emoji-click", this.onEmojiClick);

    this.onOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.close();
    };
  }

  disconnect() {
    this.picker?.removeEventListener("emoji-click", this.onEmojiClick);
    document.removeEventListener("click", this.onOutsideClick);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.panelTarget.classList.contains("hidden")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.panelTarget.classList.remove("hidden");
    document.addEventListener("click", this.onOutsideClick);
  }

  close() {
    this.panelTarget.classList.add("hidden");
    document.removeEventListener("click", this.onOutsideClick);
  }
}
